import type { ReactNode } from 'react';
import { Page, EmptyState, Tag } from '../ui';

export function ComingSoon({
  title,
  subtitle,
  icon,
  pitch,
  bullets,
}: {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  pitch: string;
  bullets: string[];
}) {
  return (
    <Page
      title={title}
      subtitle={subtitle}
      badges={
        <Tag tone="soon" style={{ marginLeft: 8 }}>
          em breve
        </Tag>
      }
    >
      <EmptyState
        icon={icon}
        title={pitch}
        description={
          <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0 0', textAlign: 'left' }}>
            {bullets.map((b, i) => (
              <li
                key={i}
                style={{
                  padding: '6px 0',
                  borderBottom:
                    i < bullets.length - 1 ? '1px solid var(--color-border-subtle)' : 'none',
                }}
              >
                <span style={{ color: 'var(--color-accent)', marginRight: 8 }}>›</span>
                {b}
              </li>
            ))}
          </ul>
        }
      />
    </Page>
  );
}
